import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './PasswordForget';
import { auth } from '../firebase';
import * as routes from '../constants/routes';

import { Link } from 'react-router-dom';
import {Navbar, Icon} from 'react-materialize'
import { firebase } from '../firebase';

// const Navigation = ({ authUser, history }) =>
//       <AuthUserContext.Consumer>
//           {authUser => authUser
//             ? <NavigationAuth />
//             : <NavigationNonAuth />
//           }
//       </AuthUserContext.Consumer>

const SignInPage = ({ history }) =>
  <div>
    <center>
      <div className="section"></div>

      <h5 >Entre com sua conta</h5>
      <div className="section"></div>

      <SignInForm history={history} />

      <PasswordForgetLink />
      <SignUpLink />
    </center>
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {

  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
    this.history = props.history ;
  }

  onFacebookLogin = (event) => {
    console.log("facebook login inicio");
    auth.doSignInWithFacebook();
      // .then(() => {
      //   console.log("facebook login fim");
      //   // this.setState(() => ({ ...INITIAL_STATE }));
      //   // history.push(routes.HOME);
      // })
      // .catch(error => {
      //   this.setState(byPropKey('error', error));
      // });
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.HOME);
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  componentDidMount() {
    firebase.auth.onAuthStateChanged(authUser => {
      if(authUser){
          this.history.push(routes.HOME);
      }
    });
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    return (
      <div className="container">
        <div className="z-depth-1 grey lighten-4 row" >

          <form className="col s12" onSubmit={this.onSubmit}>
            <div className='row'>
              <div className='col s12'>
              </div>
            </div>

            <div className='row'>
              <div className='input-field col s12'>
                <input
                  className='validate'
                  type='email'
                  name='email'
                  id='email'
                  value={email}
                  onChange={event => this.setState(byPropKey('email', event.target.value))}
                />
                <label htmlFor="email">Endereço de Email</label>
              </div>
            </div>

            <div className='row'>
              <div className='input-field col s12'>
                <input
                  className='validate' name='password' id='password'
                  value={password}
                  id='password'
                  type="password"
                  onChange={event => this.setState(byPropKey('password', event.target.value))}
                />
                <label htmlFor="password">Senha</label>
              </div>
            </div>

            <br />
            <center>
              <div className='row'>
                <button type='submit' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Login<Icon>keyboard_arrow_right</Icon></button>
                { error && <p>{error.message}</p> }
              </div>
            </center>
          </form>
            <div className='row'>
              <div className='col s12'>
                <button onClick={this.onFacebookLogin} type='button' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Facebook<Icon>keyboard_arrow_right</Icon></button>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const continueForm = () =>
<div className="container">
  <div className="z-depth-1 grey lighten-4 row" >

    <form className="col s12" onSubmit={this.onSubmit}>
      <div className='row'>
        <div className='col s12'>
          Bemvindo
        </div>
      </div>
      <br />
      <center>
        <div className='row'>
          <button type='submit' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Login</button>

        </div>
      </center>
    </form>
    <center className="col s12">
      <div className='row'>
        <button onClick={this.onFacebookLogin} type='button' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Continuar</button>
      </div>
    </center>
  </div>
</div>

export default withRouter(SignInPage);

export {
  SignInForm,
};



// WEBPACK FOOTER //
// ./src/components/SignIn.js